import { makeSvgDataSrc } from "@sphtech/dmg-design-system";

import landscapeSrc from "./landscape.svg";

const fallbackSvg = makeSvgDataSrc({
  width: 200,
  height: 200,
  text: "HOME&#183;DECOR",
});

const hndPlaceholders = {
  landscape: {
    src: landscapeSrc,
    srcWidth: 1080,
    srcHeight: 720,
    alt: "",
  },
  portrait: {
    src: fallbackSvg,
    srcWidth: 768,
    srcHeight: 1024,
    alt: "",
  },
  square: {
    src: landscapeSrc,
    srcWidth: 315,
    srcHeight: 315,
    alt: "",
  },
  wide: {
    src: landscapeSrc,
    srcWidth: 1000,
    srcHeight: 500,
    alt: "",
  },
};

export default hndPlaceholders;
